import * as React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import { useTranslation } from "react-i18next";
import MenuList from "@mui/material/MenuList";
import { Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";

import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useSearchParams } from "react-router-dom";
import ModalDialog from "../meters/ModalDialog";
import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { store } from "../../redux/store";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../redux/slices/iwdWebSocketSlice";

import { worklistActions } from "../../redux/slices/worklistSlice";
import { loadingOn, loadingOff } from "../../redux/slices/loadingSlice";
/* const url = "http://192.168.1.94:4006/api/v1/altior/device/export/download?";  344*/

const WorklistDeviceDpwnloader = ({ styleProp, params }) => {
  const url = `${window.BASE_URL}/api/v1/altior/download/device/export?`;
  const bearer = localStorage.getItem("user_token");
  const options = ["Export XLSX"];
  const loading = useSelector((state) => state?.loadingSlice?.loading);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [uuid, setUUID] = useState();
  const downloadData = useSelector(
    (state) => state?.worklistSlice?.devicesToDownload
  );
  const [startDownload, setStartDownload] = useState(false);
  const dispatch = useDispatch();
  let [searchParams] = useSearchParams();
  useEffect(() => {}, [url]);

  const [
    startExportDevice,
    {
      isLoading: isDeviceExportLoading,
      isSuccess: isDeviceExportSuccess,
      isError: isDeviceExportError,
      data: resultStartExport,
      requestId,
    },
  ] = store.useLazyStartExportQuery();
  const [
    downloadDevice,
    {
      isSuccess: isDeviceDownloadSuccess,
      isError: isDeviceDownloadError,
      data: resultStartDownload,
      reset: resetStartDownload,
    },
  ] = store.useDownloadMutation();
  const {
    isWSConnected,
    subscribedChannels,
    data,
    error,
    channels,
    cashedData,
  } = useSelector((state) => state.iwdWebSocketSlice);
  const { t } = useTranslation();
  useEffect(() => {
    // 1
    dispatch(loadingOff());
  }, [isDeviceDownloadSuccess, isDeviceDownloadError]);

  useEffect(() => {
    if (isWSConnected && !channels["export_status"]) {
      let requestUuid = uuidv4();
      setUUID(requestUuid);

      dispatch(
        actions.joinChannel({
          name: "export_status",
          params: { uuid: requestUuid },
        })
      );
    }
  }, [isWSConnected]);

  useEffect(() => {
    if (
      data &&
      isWSConnected &&
      ((data?.data_update?.[0]?.uuid == uuid &&
        data?.data_update?.[0]?.status == "ready") ||
        (cashedData?.[0]?.uuid == uuid && cashedData?.[0]?.status == "ready"))
    ) {
      const copySearchParams = new URLSearchParams(searchParams);
      copySearchParams.append("download_type", "excel");
      copySearchParams.append("uuid", uuid);
      copySearchParams.append("token", bearer);
      copySearchParams.append("in_polygon", `${JSON.stringify(downloadData)}`);
      window.open(`${url}${copySearchParams.toString()}`, "_blank");
      dispatch(loadingOff());
      dispatch(worklistActions.resetDeviceToDownload());
    }
  }, [data, data?.data_update, data.data_update?.status, cashedData]);
  useEffect(() => {
    if (!isWSConnected) {
      dispatch(actions.connect());
    }
  }, [isWSConnected]);

  useEffect(() => {
    if (
      channels["export_status"] &&
      (!subscribedChannels["export_status"] ||
        !subscribedChannels["export_status"]["data_update"])
    ) {
      dispatch(
        actions.subscribeChannel({
          channelName: "export_status",
          eventName: "data_update",
        })
      );

      if (startDownload) {
        const copySearchParams = new URLSearchParams(searchParams);

        copySearchParams.append("download_type", "excel");
        copySearchParams.append("uuid", uuid);
        copySearchParams.append(
          "in_polygon",
          `${JSON.stringify(downloadData)}`
        );
        startExportDevice(copySearchParams);
        setStartDownload(false);
      }
    }
  }, [channels]);
  useEffect(() => {
    if (!isDeviceExportLoading) {
      switch (resultStartExport) {
        case "already_created":
          const copySearchParams = new URLSearchParams(params);
          copySearchParams.append("download_type", "excel");
          copySearchParams.append("uuid", uuid);
          copySearchParams.append("token", bearer);
          copySearchParams.append(
            "in_polygon",
            `${JSON.stringify(downloadData)}`
          );
          window.open(`${url}${copySearchParams.toString()}`, "_blank");
          dispatch(loadingOff());
          dispatch(worklistActions.resetDeviceToDownload());
          break;
        case "creating":
          dispatch(loadingOn());
          break;
        default:
          break;
      }
    }
  }, [
    isDeviceExportSuccess,
    isDeviceExportLoading,
    requestId,
    resultStartExport,
  ]);
  useEffect(() => {}, [uuid]);
  const handleClick = () => {
    console.info(`You clicked ${options[selectedIndex]}`);

    dispatch(loadingOn());
    switch (selectedIndex) {
      case 0:
        if (!isWSConnected) {
          dispatch(actions.connect());
          setStartDownload(true);
        } else {
          const copySearchParams = new URLSearchParams(searchParams);
          copySearchParams.append("download_type", "excel");

          copySearchParams.append("uuid", uuid);
          copySearchParams.append(
            "in_polygon",
            `${JSON.stringify(downloadData)}`
          );
          startExportDevice(copySearchParams);
        }

        break;

      default:
        alert("Nothing to do");
        break;
    }
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };
  useEffect(() => {}, [resultStartExport]);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  useEffect(() => {
    if (downloadData !== null) {
      handleClick();
    }
  }, [downloadData]);

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  useEffect(() => {
    //clean up

    return () => {
      dispatch(actions.cleanData("data_update"));
      dispatch(actions.leaveChannel("export_status"));
      dispatch(worklistActions.resetDeviceToDownload());
    };
  }, []);

  return (
    <>
      {bearer && (
        <>
          <ModalDialog open={loading} title={t("note")} cancell={false}>
            <Box>{t("exporting_data")}</Box>
          </ModalDialog>
          {/*  <IconButton onClick={handleClick}>
            <CloudDownloadIcon />
          </IconButton> */}
        </>
      )}
    </>
  );
};

export default React.memo(WorklistDeviceDpwnloader);
